import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';

import { ConfigService } from '@app-core/services';
import { IconComponent } from '@app-shared/components/icon/icon.component';

@Component({
  selector: 'app-top-alert',
  templateUrl: './top-alert.component.html',
  styleUrls: ['./top-alert.component.scss'],
  imports: [AsyncPipe, IconComponent],
})
export class TopAlertComponent {
  private _configService = inject(ConfigService);

  error$ = this._configService.error$;
  newVersion$ = this._configService.newVersion$;

  dismissError(): void {
    this._configService.hideErrorMessage();
  }

  dismissNewVersion(): void {
    this._configService.hideNewVersionMessage();
  }
}
